import { Entry } from '../Entry'

export function Entry20250226() {
  return (
    <Entry title="2025 Feb 26 - v3.10.4">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16237/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
